import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3 17.813c0-.468.376-.844.844-.844h2.099a2.811 2.811 0 0 1 5.364 0h8.85c.467 0 .843.376.843.843a.84.84 0 0 1-.844.844h-8.849a2.811 2.811 0 0 1-5.364 0h-2.1A.84.84 0 0 1 3 17.813m6.75 0a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0m6.75-5.625a1.125 1.125 0 1 0-2.25 0 1.125 1.125 0 0 0 2.25 0m-1.125-2.813c1.259 0 2.324.826 2.682 1.969h2.1c.467 0 .843.376.843.844a.84.84 0 0 1-.844.843h-2.099a2.811 2.811 0 0 1-5.364 0h-8.85A.84.84 0 0 1 3 12.187c0-.467.376-.843.844-.843h8.849a2.81 2.81 0 0 1 2.682-1.969M9.75 5.438a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m2.682.28h7.724c.468 0 .844.377.844.845a.84.84 0 0 1-.844.843h-7.724a2.811 2.811 0 0 1-5.364 0H3.844A.84.84 0 0 1 3 6.563c0-.468.376-.844.844-.844h3.224a2.811 2.811 0 0 1 5.364 0"
    }, null, -1)
  ]))]))
}
export default { render: render }